import script from "./FooterCollapsible.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterCollapsible.vue?vue&type=script&setup=true&lang=js"

import "./FooterCollapsible.vue?vue&type=style&index=0&id=a7f04f2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7f04f2e"]])

export default __exports__